import { GridColDef } from "@mui/x-data-grid-premium";
import { Box, Dialog, Divider, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

// Fms activity table column definitions used in FmsActivityTable.tsx
export const fmsActivityTableColumnDefs: GridColDef[] = [
  {
    field: "id",
    headerName: "Location ID",
    flex: 1,
    minWidth: 120,
    headerAlign: "left",
    align: "left",
    renderHeader: () => <StyledHeader>Location ID</StyledHeader>,
    renderCell: (params) => <StyledCell>{params.value}</StyledCell>,
  },
  {
    field: "relationshipId",
    headerName: "Relationship ID",
    flex: 1,
    minWidth: 150,
    headerAlign: "left",
    align: "left",
    renderHeader: () => <StyledHeader>Relationship ID</StyledHeader>,
    renderCell: (params) => <StyledCell>{params.value}</StyledCell>,
  },
  {
    field: "locationName",
    headerName: "Location Name",
    flex: 1,
    minWidth: 200,
    headerAlign: "left",
    align: "left",
    renderHeader: () => <StyledHeader>Location Name</StyledHeader>,
    renderCell: (params) => <StyledCell>{params.value}</StyledCell>,
  },
  {
    field: "llcName",
    headerName: "LLC Name",
    flex: 1,
    minWidth: 200,
    headerAlign: "left",
    align: "left",
    renderHeader: () => <StyledHeader>LLC Name</StyledHeader>,
    renderCell: (params) => <StyledCell>{params.value}</StyledCell>,
  },
];

export enum ReportType {
  VACANT_SPACES = "facilityReports.vacantSpaces-SS:ctVacantSpaces",
  RENT_ROLL = "facilityReports.rentRoll-SS:dtSummaryTable",
  INSURED_TENANTS_ROLL = "facilityReports.insuredTenantsRoll-SS:dtPrivateTable",
  INSURED_TENANTS_REPORT = "facilityReports.insuredTenantsRoll-SS:dtInsuredTenantsTable",
  INSURANCE_ACTIVITY_REPORT = "facilityReports.insuranceActivity-SS:dtInsuranceTable",
}

// Report types used in FmsActivityDialog.tsx select menu
export const reportTypes = [
  {
    value: ReportType.VACANT_SPACES,
    label: "Vacant Spaces Report",
  },
  {
    value: ReportType.RENT_ROLL,
    label: "Rent Roll Summary",
  },
  {
    value: ReportType.INSURED_TENANTS_ROLL,
    label: "Private Insurance Report",
  },
  {
    value: ReportType.INSURED_TENANTS_REPORT,
    label: "Insured Tenants Report",
  },
  {
    value: ReportType.INSURANCE_ACTIVITY_REPORT,
    label: "Insurance Activity Report",
  },
];

// FMS activity styled components
const StyledHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "14px",
  color: theme.palette.text.primary,
  fontFamily: "Open Sans",
}));

const StyledCell = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: theme.palette.text.secondary,
  fontFamily: "Open Sans",
}));

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  width: "95%",
  display: "flex",
  alignSelf: "center",
  backgroundColor: "#EBEFF7",
}));

export const DatePickerContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
}));

export const DatePickerLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 600,
  fontSize: "14px",
  marginBottom: theme.spacing(1),
}));

export const ReportTypeContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const DownloadContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const DownloadInfo = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));
